module.exports = __webpack_public_path__ + "img/DQ.6681a081.png";